import React from "react";
import { Route } from "react-router-dom";
import { AreaCard } from "./AreaCard";
import { AreaEditDialog } from "./area-edit-dialog/AreaEditDialog";
import { AreaUIProvider } from "./AreaUIContext";
import { PrivateRoute } from "../../../PrivateRoute";
import { BlockOrg, RoleChecker } from "../../../RoleChecker";

export function AreaPage({ history }) {
  const areaUIEvents = {
    newAreaButtonClick: () => {
      history.push("/kurban/area/new");
    },
    openEditAreaPage: (id) => {
      history.push(`/kurban/area/${id}/edit`);
    },
  };

  return (
    <AreaUIProvider areaUIEvents={areaUIEvents}>
      <PrivateRoute
        role={BlockOrg() && RoleChecker("Create", "access_role")}
        component={AreaEditDialog}
        path="/kurban/area/new"
      />
      <PrivateRoute
        role={RoleChecker("Edit", "access_role")}
        component={AreaEditDialog}
        path="/kurban/area/:id/edit"
      />

      <Route path="/kurban/area/new">
        {({ history, match }) => (
          <AreaEditDialog
            show={match != null}
            onHide={() => {
              history.push("/kurban/area");
            }}
          />
        )}
      </Route>

      <Route path="/kurban/area/:id/edit">
        {({ history, match }) => (
          <AreaEditDialog
            show={match != null}
            id={match && match.params.id}
            onHide={() => {
              history.push("/kurban/area");
            }}
          />
        )}
      </Route>

      <AreaCard />
    </AreaUIProvider>
  );
}
